import { ParentsAbsenceRequestTable } from "../components/ParentsAbsenceRequestTable";
import { PageContainer } from "../components/PageContainer";

export const ViewParentsAbsenceRequests = () => {
  return (
    <PageContainer>
      <ParentsAbsenceRequestTable />
    </PageContainer>
  );
};
